import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Assets
import g1 from "../assets/manali.png";
import g2 from "../assets/shimla.png";
import g3 from "../assets/dharamshala.png";
import g4 from "../assets/Manali/Mcleodganj.png";

const slides = [
  { img: g1, title: "Majestic Manali", sub: "Explore the snow-capped peaks" },
  { img: g2, title: "Scenic Shimla", sub: "The Queen of Hills awaits" },
  { img: g3, title: "Peaceful Dharamshala", sub: "Discover spiritual tranquility" },
  { img: g4, title: "Mystic Mcleodganj", sub: "A blend of culture and nature" },
];

const HomeHero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  // ✅ define first
  const swipeNext = () => {
    setDirection(1);
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  // Auto-play
  useEffect(() => {
    const timer = setInterval(() => {
      swipeNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const slideVariants = {
    enter: (direction) => ({
      clipPath: direction > 0 ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)',
      opacity: 0,
      scale: 1.2
    }),
    center: {
      clipPath: 'inset(0 0 0 0%)',
      opacity: 1,
      scale: 1,
      transition: {
        clipPath: { type: "spring", stiffness: 100, damping: 20 },
        scale: { duration: 0.8 },
        opacity: { duration: 0.4 }
      }
    },
    exit: (direction) => ({
      clipPath: direction < 0 ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)',
      opacity: 0,
      scale: 1.1,
      transition: { duration: 0.5 }
    })
  };

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black">

      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={currentIndex}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          className="absolute inset-0 flex flex-col items-center justify-center"
        >
          <img
            src={slides[currentIndex].img}
            alt="Destination"
            className="object-cover"
            style={{
              borderRadius: "50%",
              height: "500px",
              width: "500px",
              maxWidth: "90%",
            }}
          />

          <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-center text-center px-4">
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4"
            >
              {slides[currentIndex].title}
            </motion.h1>

            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7 }}
              className="text-lg sm:text-xl md:text-2xl text-gray-200 uppercase"
            >
              {slides[currentIndex].sub}
            </motion.p>
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, idx) => (
          <div key={idx} className="h-2 w-14 bg-white/30 rounded-full overflow-hidden">
            {idx === currentIndex && (
              <motion.div
                className="h-full bg-white w-full"
                initial={{ x: '-100%' }}
                animate={{ x: 0 }}
                transition={{ duration: 5, ease: "linear" }}
              />
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default HomeHero;